/*
 * Copyright (c) 2025 Marijan Nikic
 * This code is distributed under the Code Project Open License (CPOL) v1.02.
 * For more details, please refer to: http://www.codeproject.com/info/cpol10.aspx
 *
 * The software is provided "AS IS", without any express or implied warranties.
 * Original code extracted from: "Regex for Cron Expressions"
 * https://www.codeproject.com/Tips/5299523/Regex-for-Cron-Expressions
 *
 * Additional restriction: The accompanying Articles may not be redistributed
 * without the prior consent of the Author. This notice must be retained in all copies
 * or derivative works.
 */
export const cronRegex = new RegExp([
    '^',
    [
        // second
        '(\\*|(?:\\*|(?:[0-9]|(?:[1-5][0-9])))\\/(?:[0-9]|(?:[1-5][0-9]))|(?:[0-9]|(?:[1-5][0-9]))(?:(?:\\-[0-9]|\\-(?:[1-5][0-9]))?|(?:\\,(?:[0-9]|(?:[1-5][0-9])))*))', 
        // minute
        '(\\*|(?:\\*|(?:[0-9]|(?:[1-5][0-9])))\\/(?:[0-9]|(?:[1-5][0-9]))|(?:[0-9]|(?:[1-5][0-9]))(?:(?:\\-[0-9]|\\-(?:[1-5][0-9]))?|(?:\\,(?:[0-9]|(?:[1-5][0-9])))*))',
        // hour
        '(\\*|(?:\\*|(?:\\*|(?:[0-9]|1[0-9]|2[0-3])))\\/(?:[0-9]|1[0-9]|2[0-3])|(?:[0-9]|1[0-9]|2[0-3])(?:(?:\\-(?:[0-9]|1[0-9]|2[0-3]))?|(?:\\,(?:[0-9]|1[0-9]|2[0-3]))*))',
        // day_of_month
        '(\\*|\\?|L(?:W|\\-(?:[1-9]|(?:[12][0-9])|3[01]))?|(?:[1-9]|(?:[12][0-9])|3[01])(?:W|\\/(?:[1-9]|(?:[12][0-9])|3[01]))?|(?:[1-9]|(?:[12][0-9])|3[01])(?:(?:\\-(?:[1-9]|(?:[12][0-9])|3[01]))?|(?:\\,(?:[1-9]|(?:[12][0-9])|3[01]))*))',
        // month
        '(\\*|(?:[1-9]|1[012]|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(?:(?:\\-(?:[1-9]|1[012]|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))?|(?:\\,(?:[1-9]|1[012]|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))*))',
        // day_of_week
        '(\\*|\\?|[0-6](?:L|\\#[1-5])?|(?:[0-6]|SUN|MON|TUE|WED|THU|FRI|SAT)(?:(?:\\-(?:[0-6]|SUN|MON|TUE|WED|THU|FRI|SAT))?|(?:\\,(?:[0-6]|SUN|MON|TUE|WED|THU|FRI|SAT))*))',
        // year
        //'(\\*|(?:[1-9][0-9]{3})(?:(?:\\-[1-9][0-9]{3})?|(?:\\,[1-9][0-9]{3})*))'
    ].join(' '),
    '$'
].join(''));